import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getAdmin } from '../services/api';

function Signin() {
  const [apiKey, setApiKey] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!apiKey.trim()) {
      alert('Please enter your API key');
      return;
    }

    try {
      // Temporarily set the API key to test it
      localStorage.setItem('api_key', apiKey.trim());
      // Test the API key by calling the admin endpoint
      const data = await getAdmin();
      if (data.success) {
        // Key is valid, proceed
        navigate('/admin');
      } else {
        // Remove invalid key
        localStorage.removeItem('api_key');
        alert('Invalid API key');
      }
    } catch (error) {
      // Remove invalid key
      localStorage.removeItem('api_key');
      alert('Invalid API key');
    }
  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-center">
        <div className="col-lg-6">
          <div className="text-center mb-4">
            <h1 className="display-5 fw-light text-muted">Admin Sign In</h1>
            <p className="lead text-muted">Enter your API key to access the admin panel</p>
          </div>
          <div className="card border-0 shadow-sm">
            <div className="card-body p-4">
              <form onSubmit={handleSubmit}>
                <div className="mb-3">
                  <label className="form-label text-muted">API Key</label>
                  <input
                    type="text"
                    value={apiKey}
                    onChange={(e) => setApiKey(e.target.value)}
                    placeholder="Enter your API key"
                    required
                    className="form-control border-0 bg-light"
                  />
                </div>
                <div className="text-center">
                  <button type="submit" className="btn btn-outline-primary btn-lg px-5 py-3 rounded-pill">
                    Sign In
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Signin;
